import { BsArrowRight } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import { scrollTop } from '../../utils/utils';
import ProductCard from '../product-card/product-card.component';
import './category-preview.styles.scss';

const CategoryPreview = ({ title, products }) => {
  return (
    <section className="category-preview">
      <div className="category-preview-head">
        <h2 className="category-preview-title">{title}</h2>

        <Link className="brand-link" to={title} onClick={scrollTop}>
          Voir la catégorie
          <span className="brand-link-arrow" aria-hidden="true">
            <BsArrowRight />
          </span>
        </Link>
      </div>

      <div className="product-grid">
        {products.items.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </section>
  );
};

export default CategoryPreview;
